module.exports = __webpack_public_path__ + "img/hr-distractor-robot-shadow.562999ea.png";